import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AdminHeader.css';

const AdminHeader = ({ adminName = 'Администратор' }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    console.log('Выход из системы');
    navigate('/');
  };

  const handleGoToMain = () => {
    window.location.href = '/';
  };

  const handleNavigation = (path) => {
    navigate(`/admin${path}`);
    setIsDropdownOpen(false);
  };

  const getActiveButton = () => {
    const path = location.pathname;
    if (path.includes('/locations')) return 'locations';
    if (path.includes('/categories')) return 'categories';
    if (path.includes('/users')) return 'users';
    if (path.includes('/analytics')) return 'analytics';
    if (path.includes('/news')) return 'news';
    return null;
  };

  const activeButton = getActiveButton();

  return (
    <header className="admin-header">
      <div className="admin-header__left">
        <div className="admin-header__user">
          <span className="admin-header__username">{adminName}</span>
          <button 
            className="admin-header__dropdown-btn"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            ▼
          </button>
          {isDropdownOpen && (
            <div className="admin-header__dropdown">
              <button onClick={handleGoToMain}>На главную</button>
              <button onClick={handleLogout}>Выйти</button>
            </div>
          )}
        </div>
      </div>

      <nav className="admin-header__nav">
        <button 
          className={`admin-header__nav-btn ${activeButton === 'locations' ? 'active' : ''}`}
          onClick={() => handleNavigation('/locations')}
        >
          Управление локациями/маршрутами
        </button>
        <button 
          className={`admin-header__nav-btn ${activeButton === 'categories' ? 'active' : ''}`}
          onClick={() => handleNavigation('/categories')}
        >
          Управление категориями/тегами
        </button>
        <button 
          className={`admin-header__nav-btn ${activeButton === 'users' ? 'active' : ''}`}
          onClick={() => handleNavigation('/users')}
        >
          Управление админами
        </button>
        <button 
          className={`admin-header__nav-btn ${activeButton === 'analytics' ? 'active' : ''}`}
          onClick={() => handleNavigation('/analytics')}
        >
          Аналитика
        </button>
        <button 
          className={`admin-header__nav-btn ${activeButton === 'news' ? 'active' : ''}`}
          onClick={() => handleNavigation('/news')}
        >
          Новости и объявления
        </button>
      </nav>
    </header>
  );
};

export default AdminHeader;